import { TableCell } from '@mui/material';
import PropTypes from 'prop-types';
import { cellColorsNew } from '../../shared/constants/commonCellColors';
import stylizeCell from '../../shared/functions/cellStyling';
import CellSelector from '../Cells/CellSelector';
import CellViewer from '../Cells/CellViewer';
import { IssueAndServiceSharedValues } from '../../shared/constants/IssueAndServiceKeys';
import sxPropType from '../../shared/propTypes/sxPropType';

const CELL_STYLE_KEYS = {
  ...Object.keys(cellColorsNew).reduce((acc, key) => ({ ...acc, [key]: key }), {}),
  input: 'input',
  cell: 'cell',
  label: 'label',
};

export default function TrackerTableDataCell({
  cells,
  index,
  isEditMode,
  onEdit,
  onOpenFullEntryEditor,
  dropdownTable,
  className,
  id,
  type,
  isSharedResource = false,
  cellSx,
}) {
  const stylizedCellKey =
    index === IssueAndServiceSharedValues.campaign ? '' : stylizeCell(cells[index], CELL_STYLE_KEYS, index);

  const resolvedCellSx = stylizedCellKey && stylizedCellKey !== 'normal' ? cellColorsNew[stylizedCellKey] : null;
  const selectorClasses = {
    input: '',
    label: '',
  };

  if (!isEditMode) {
    return (
      <TableCell className={className} sx={[{ maxWidth: 210 }, resolvedCellSx, cellSx]} align="left">
        <CellViewer
          type={type}
          cells={cells}
          index={index}
          dropdownTable={dropdownTable}
          id={id}
          isSharedResource={isSharedResource}
          onOpenFullEntryEditor={onOpenFullEntryEditor}
        />
      </TableCell>
    );
  } else {
    return (
      <TableCell className={className} sx={[{ maxWidth: 210 }, resolvedCellSx, cellSx]} align="left">
        <CellSelector
          type={type}
          cells={cells}
          col={index}
          dropdownTable={dropdownTable}
          callBack={onEdit}
          id={id}
          classes={selectorClasses}
          inputSx={{ width: 130, height: 40 }}
          labelSx={{ minWidth: 150 }}
        />
      </TableCell>
    );
  }
}

TrackerTableDataCell.propTypes = {
  cells: PropTypes.object,
  cellSx: sxPropType,
  className: PropTypes.string,
  dropdownTable: PropTypes.object,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  index: PropTypes.string,
  isEditMode: PropTypes.bool,
  isSharedResource: PropTypes.bool,
  onEdit: PropTypes.func,
  onOpenFullEntryEditor: PropTypes.func,
  type: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
